<template>
  <swiper ref="mobileSwiper" :options="mobileSwiperOptions">
    <swiper-slide v-for="(item, index) in vbannerlists" :key="index">
      <img
       style="width:100%"
        v-lazy="item.img"
        :data-src="item.img"
        :title="item.name"
        :alt="item.name"
      />
    </swiper-slide>
  </swiper>
</template>

<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
// import vueSwiper from 'vue-awesome-swiper'
//import 'swiper/css/swiper.css'
import "swiper/swiper-bundle.css";
//import { swiper, swiperSlide } from "vue-awesome-swiper";
/* 样式的话，我这里有用到分页器，就在全局中引入了样式 */
// import 'swiper/dist/css/swiper.css'

export default {
  name: "Banner",
  data() {
    return {
      //  height:'',//300px'

      mobileSwiperOptions: {
        pagination: {
          //  el: '.swiper-pagination'
        },
      },
    };
  },
  props: ["vbannerlists", "vbannerlistsheight"],

  components: {
    Swiper,
    SwiperSlide,
    directive,
  },

  //mobileSwiper <swiper ref="mobileSwiper" :options="mobileSwiperOptions">
  computed: {
    swiper() {
      return this.$refs.mobileSwiper.$swiper;
    },
  },
  mounted() {
    // console.log('Current Swiper instance object', this.swiper)
    // this.swiper.slideTo(3, 1000, false)
  },

  // title: {
  //   type: String,
  //   default: ""
  // },
  // img: {
  //   type: String,
  //   default: "../../../assets/login-bg-2.jpg"
  // }
  // props: {}
};
</script>

<style   scoped>
</style>



// WEBPACK FOOTER //
// src/components/page/tmp/mobile/banner.vue